import React from 'react';
import { Paper, Grid, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';

import { translate } from 'react-i18next';

const styles = theme => ({
    //    root: theme.mixins.gutters({
    //     paddingTop: 16,
    //     paddingBottom: 16,
    //     marginTop: theme.spacing.unit * 3,
    //   }),
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    paperFrame: {
        margin: '25px 0px 20px 0px'
    }
});

function renderTerms(services) {
    if (services) {
        let all = [];
        if (!Array.isArray(services)) {
            services = [{ description: services }];
        }

        services.map(t => {
            let terms = String(t.description).split(/[\r\n]+/);
            terms.map(t => t = String(t).trim());
            //terms = terms.filter(t => t != '');
            terms.map(t => t += '<br />');
            all.push(terms.join('<br />'));
        });
        all.map(t => t = '<p>' + t + '</p>');
        return { __html: all.join('<br />') };
    }
    else {
        return { __html: '' };
    }
}

class ReservationTermsRender extends React.Component {

    renderTerm = (rooms) => {
        rooms = rooms.filter(room => room.associatedServices.length > 0);
        return rooms.map((room, id) => {
            return room.associatedServices &&
                room.associatedServices.length > 0 &&
                <div key={id}>
                    <Typography>
                        <b>{room.service.description}</b>
                    </Typography>
                    <Typography dangerouslySetInnerHTML={renderTerms(room.associatedServices)}>
                    </Typography>
                    <br />
                </div>;
        });
    };

    render() {
        const { reservation, isNew, classes, t } = this.props;
        let rooms = [];
        if (reservation) {
            rooms = reservation.rooms;
        }
        const isAssociatedServices = rooms.some(r => r.associatedServices && r.associatedServices.length);
        return (
            <Paper className={classes.paperFrame}>
                <Typography className={classes.bookingTitle}>
                    {t('BOOKING_DETAIL.BOOKING_TERMS')}
                </Typography>
                <Grid container>
                    {isAssociatedServices && !reservation.importantNotes &&
                        <Grid item xs={12}>
                            <article>
                                {this.renderTerm(rooms)}
                            </article>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <article>
                            {reservation && reservation.importantNotes &&
                                (<Typography dangerouslySetInnerHTML={renderTerms(reservation.importantNotes)}></Typography>)
                            }
                        </article>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationTermsRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationTermsRender.js